import dayjs from "dayjs";
import { StripeBankTransferSettlementDTO } from "../../../Stripe/StripeOrderDTO.ts";
import { Link } from "react-router";
import { toBonificoOrdersSearchPath } from "../../BonificoOrder/bonificoOrdersListPath.ts";
import { formatDateRome } from "../../../UI/Utils/formatDateRome.ts";

function DetailRow({ label, value }: { label: string; value: string }) {
  return (
    <div>
      <span className="font-medium text-gray-700">{label}:</span>
      <p className="text-gray-600">{value}</p>
    </div>
  );
}

function formatEuros(amountInCents: number): string {
  return `€${(amountInCents / 100).toFixed(2)}`;
}

export function BankTransferSettlementDetails({
  settlement,
  orderId,
}: {
  settlement: StripeBankTransferSettlementDTO;
  orderId: string;
}) {
  return (
    <div className="grid grid-cols-1 md:grid-cols-2 gap-3 text-sm">
      <DetailRow
        label="Importo saldato con bonifico"
        value={formatEuros(settlement.amountInCents.amount)}
      />
      <DetailRow
        label="Già pagato su Stripe"
        value={formatEuros(settlement.amountAlreadyPaidInCents.amount)}
      />
      <DetailRow
        label="Data della contabile"
        value={dayjs(settlement.receiptDateUtc).format("DD/MM/YYYY")}
      />
      <DetailRow
        label="Registrato il"
        value={formatDateRome(settlement.settledAtUtc)}
      />
      <Link
        className="text-blue-600 hover:underline md:col-span-2"
        to={toBonificoOrdersSearchPath(orderId)}
      >
        Vedi l'ordine bonifico collegato
      </Link>
    </div>
  );
}
